import { mapGetters } from 'vuex'
import { toast } from './toast'

const SSP_PORTAL = 'd300660e4320d8d5c8ecb48035b67815'
const SSENSOR = 'dc162b04e8657157714050bce3908060'
const FOLHA_SSERTA = '4c4304a34cb2b71997da043e7b8e15e0'
const CONSSILIA = '671d18739e2b47758ec60db8dfbd2a2a'
const ALERTA_DISSIDIO = '697a34e617dd4553ba19db895ec570bb'
const SSMART_CHECK = 'b90805241c3b43758a6704d312eed628'
const LANCE_SSIMPLES = '9c19074dd1c9518936d665f2b2e7c434'

export const productSwitch = {

  SSP_PORTAL: SSP_PORTAL,
  SSENSOR: SSENSOR,
  FOLHA_SSERTA: FOLHA_SSERTA,
  mixins: [toast],

  data() {
    return {
      _products: [
        {
          enabled: true,
          id: FOLHA_SSERTA,
          name: 'Folha Sserta',
          img: '../../.././static/img/logo-folha-sserta.svg',
          description: 'Lançamento e conferência automática de folhas de pagamento.',
          addresses: {
            development: 'https://folhasserta.ssparisi.com/',
            production: 'https://folhasserta.ssparisi.com/'
          }
        },
        {
          enabled: true,
          id: CONSSILIA,
          name: 'Conssilia+',
          img: '../../.././static/img/logo-conssilia.svg',
          description: 'Conciliação automática de Fornecedores e Clientes.',
          addresses: {
            development: 'https://conssilia.ssparisi.com/',
            production: 'https://conssilia.ssparisi.com/'
          }
        },
        {
          enabled: true,
          id: SSMART_CHECK,
          name: 'SSmart Check',
          img: '../../.././static/img/logo-ssmart-check.svg',
          description: 'Conferência de vendas em cartão.',
          addresses: {
            development: 'https://ssmartcheck.ssparisi.com/',
            production: 'https://ssmartcheck.ssparisi.com/'
          }
        },
        {
          enabled: true,
          id: ALERTA_DISSIDIO,
          name: 'Alerta Dissídio',
          img: '../../.././static/img/logo-alerta-dissidio.svg',
          description: 'Monitoramento de Convenções Coletivas.',
          addresses: {
            development: 'https://alertss.ssparisi.com/',
            production: 'https://alertss.ssparisi.com/'
          }
        },
        {
          enabled: true,
          id: LANCE_SSIMPLES,
          name: 'Lance SSimples',
          description: 'Lançamentos Contábeis automatizados sem digitação.',
          img: '../../.././static/img/logo-lancessimples.svg',
          addresses: {
            development: 'https://hml-lss.ssparisi.com/',
            production: 'https://lss.ssparisi.com/'
          }
        }
      ]
    }
  },

  methods: {
    ...mapGetters(['getProductId', 'getCompany']),

    switchTo (productId) {
      if(productId === this.currentProductId) return

      const product = this.getProductById(productId)
      if(product.enabled) {
        const token = localStorage.getItem('token')
        const address = product.addresses[process.env.NODE_ENV]
        window.open(address, '_blank')
      } else {
        this.show_toast('info', 'Sem acesso', `Você ainda não tem acesso ao ${product.name}.`)
      }
    },

    getProductById(id) {
      return this.$data._products.find(product => product.id === id);
    }

  },

  computed: {
    currentProductId() {
      return this.getProductId()
    }
  }

}



// WEBPACK FOOTER //
// ./src/mixins/product-switch.js